import { render, staticRenderFns } from "./BgSoundItem.vue?vue&type=template&id=3c719674&scoped=true"
import script from "./BgSoundItem.vue?vue&type=script&lang=js"
export * from "./BgSoundItem.vue?vue&type=script&lang=js"
import style0 from "./BgSoundItem.vue?vue&type=style&index=0&id=3c719674&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c719674",
  null
  
)

export default component.exports